import type { ReactNode } from "react";

export type PillTone = "ok" | "warn" | "error" | "pending" | "accent" | "neutral";

interface StatusPillProps {
  tone?: PillTone;
  dot?: boolean;
  children: ReactNode;
}

/** Compact status chip — ok / warn / error / pending / accent. */
export function StatusPill({ tone = "neutral", dot = false, children }: StatusPillProps) {
  const cls = tone === "neutral" ? "" : `pill--${tone}`;
  return (
    <span className={`pill ${cls}`}>
      {dot && <span className="pill__dot" aria-hidden />}
      {children}
    </span>
  );
}
